import React from "react";
import ContentLoader from "react-content-loader";

function PostFeedLoading() {
  return (
    <div className="article img clearfix">
      <ContentLoader
        speed={2} // 속도
        // width={530}
        // height={180}
        viewBox="0 0 500 315"
        backgroundColor="#27292d" // 배경색
        foregroundColor="#4b4b4b" // 요소 색
      >
        <circle cx="15" cy="15" r="12" />
        <rect x="32" y="4" rx="3" ry="3" width="52" height="10" />
        <rect x="32" y="18" rx="3" ry="3" width="88" height="10" />

        <rect x="8" y="36" rx="2" ry="2" width="485" height="270" />
      </ContentLoader>
    </div>
  );
}

export default PostFeedLoading;
